import { Fragment } from "react/jsx-runtime";
import MusicCard from "../MusicCard/MusicCard";
import clearImg from "@/assets/create-space/script-clear.png";
import useCoverAndBg from "@/useStore/quickCut/useCoverAndBg";
import { IMusicResponse } from "@/services/mixCutDetail/mixCutDetail";
import { observer } from "mobx-react";
import React, {useEffect, useRef, useState} from "react";
import MusicPlayer from "./MusicPlayer/MusicPlayer";
import { Spin, Message } from "@arco-design/web-react";
import "./BgMusicContainer.less";
import QuickStore from "@/stores/quickCutStore";

export interface BgMusicContainerProps {
  style?: React.CSSProperties;
  loading: boolean;
  data: IMusicResponse[];
  handleMusicCollectBtcClick: (id: number) => void;
  handleCancelCollectBtnClick: (id: number) => void;
  hasMore: boolean;
  getList: (page?: number, isAppend?: boolean) => void;
}

const BgMusicContainer: React.FC<BgMusicContainerProps> = observer((props) => {
  const {
    style,
    data,
    loading,
    handleMusicCollectBtcClick,
    handleCancelCollectBtnClick,
    hasMore,
    getList
  } = props;
  const { bgAudio, handleBgAudiosChange } = useCoverAndBg();
  const { background } = QuickStore.quickcutData.settings;
  const [currentId, setCurrentId] = useState<number>(null);
  const loadMoreRef = useRef(null)
  const [imgPage, setImgPage] = useState(1);
  const [currentMusic, setCurrentMusic] = useState<{
    src: string;
    title: string;
    isPlay: boolean;
    duration: number;
  }>(null);
  const handleCheckStateChange = (e: boolean, id: number) => {
    if (e) {
      if (background.musics?.length === 200) {
        Message.warning("最多只能选择200首背景音乐");
        return;
      }
      const item = data.find((item) => item.id === id);
      background.musics = [
        ...bgAudio,
        { ...item, duration: item.duration * 1000 },
      ]
    } else {
      const index = bgAudio.findIndex((item) => item.id === id);
      bgAudio.splice(index, 1);
      background.musics = [...bgAudio]
    }
  };

  useEffect(() => {
    setCurrentMusic(null);
  }, [data]);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loading && hasMore) {
          const nextPage = imgPage + 1;
          setImgPage(nextPage);
          getList(nextPage, true);
        }
      },
      { root: null, rootMargin: '0px', threshold: 0.1 }
    );
    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }
    return () => {
      if (loadMoreRef.current) {
        observer.unobserve(loadMoreRef.current);
      }
    };
  }, [loading, hasMore, imgPage]);

  return (
    <div className="bg-music-container1" style={style}>
      {!data || data.length === 0 ? (
        <div className="empyt">
          <img src={clearImg} alt="" />
          <p>暂无数据</p>
        </div>
      ) : (
        <>
          {/* <div className="chose-wrapper">已选择：{bgAudio.length}</div> */}

          <div className="music-card-wrapper">
            <Spin
              loading={loading}
              style={{width: "100%", height: "100%"}}
              className={"music-card-container"}>
              {data.map((item) => {
                return (
                  <Fragment key={item.author_name + item.title + item.id}>
                    <MusicCard
                      handleCheckMusic={(e) => {
                        handleCheckStateChange(e, item.id);
                      }}
                      currentId={currentId}
                      handleCancelCollectBtnClick={() => {
                        handleCancelCollectBtnClick(item.id);
                      }}
                      hanldeCollectBtnClick={() => {
                        handleMusicCollectBtcClick(item.id);
                      }}
                      onClick={() => {
                        setCurrentMusic({
                          title: item.author_name + " - " + item.title,
                          src: item.url || item.file_url,
                          duration: item.duration,
                          isPlay: true,
                        });
                        setCurrentId(item.id);
                      }}
                      handleCheckStateChange={(e) => {
                        handleCheckStateChange(e, item.id);
                      }}
                      style={{
                        width: "calc(50% - 10px)",
                        marginRight: 9,
                        marginBottom: 9,
                        position: "sticky",
                      }}
                      checkState={
                        (bgAudio || []).findIndex(
                          (step) => item?.id === step?.id,
                        ) > -1
                      }
                      data={item}
                    />
                  </Fragment>
                );
              })}
              <div ref={loadMoreRef} style={{height: 1}} />
            </Spin>
          </div>
        </>
      )}
      {currentMusic?.isPlay ? (
        <MusicPlayer
          handleCloseBtnClick={() => {
            setCurrentMusic(null);
            setCurrentId(null);
          }}
          style={{ position: "absolute", top: 0, right: 0, left: 74, width: 'calc(100% - 120px)' }}
          duration={currentMusic.duration}
          src={currentMusic.src}
          title={currentMusic.title}
        />
      ) : (
        <></>
      )}
    </div>
  );
});

export default BgMusicContainer;
